export { DeleteConfirmationLayout } from './DeleteConfirmationLayout';
